import * as React from "react";
const SvgFiRrHouseChimneyHeart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-house-chimney-heart_svg__a)">
      <path
        fill="#062147"
        d="M22 5.735V2a1 1 0 1 0-2 0v2.367L14.797.855a4.98 4.98 0 0 0-5.594 0L2.204 5.579A4.99 4.99 0 0 0 0 9.724V19c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V9.724a4.99 4.99 0 0 0-2-3.99M22 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V9.724c0-1 .494-1.928 1.322-2.486l7-4.724A3 3 0 0 1 12 1.997a3 3 0 0 1 1.678.517l7.001 4.724A3 3 0 0 1 22 9.724zM14.212 8.923c-.906 0-1.684.284-2.25.775-.567-.491-1.344-.775-2.25-.775-1.792 0-3.25 1.56-3.25 3.476 0 2.205 2.271 4.49 4.177 6.02.383.309.853.462 1.323.462s.94-.153 1.324-.462c1.905-1.53 4.177-3.815 4.177-6.021 0-1.916-1.458-3.476-3.25-3.476zm-2.178 7.937a.12.12 0 0 1-.144 0c-2.115-1.698-3.428-3.408-3.428-4.462 0-.813.561-1.476 1.25-1.476.57 0 1.25.187 1.25 1.077a1 1 0 1 0 2 0c0-.891.68-1.077 1.25-1.077.689 0 1.25.662 1.25 1.476 0 1.054-1.313 2.764-3.428 4.46z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-house-chimney-heart_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHouseChimneyHeart;
